<div id="side-nav" class="sticky-bar">
  <div routerLink="/">
    <img
      id="logo"
      class="w-100 p-3"
      src="./../../../../assets/images/logo/CAHCCLogoTitle.png"
      alt="CAHCC Logo"
    />
  </div>
  <div id="menu-items">
    <div routerLink="/admin">
      <div>
        <fa-icon [icon]="faHome"></fa-icon>
      </div>
      <p>Front Page</p>
    </div>
    <div routerLink="/admin/menu-editor">
      <div><fa-icon [icon]="faFile"></fa-icon></div>
      <p>Menu Editor</p>
    </div>
    <div routerLink="/admin/users">
      <div><fa-icon [icon]="faUsers"></fa-icon></div>
      <p>Manage Users</p>
    </div>
    <div routerLink="/admin/subscribers">
      <div><fa-icon [icon]="faListUl"></fa-icon></div>
      <p>Subscribers</p>
    </div>
    <div routerLink="/admin/profile">
      <div><fa-icon [icon]="faGear"></fa-icon></div>
      <p>Account</p>
    </div>
  </div>
</div>
<div id="admin-layout" class="d-flex align-items-stretch">
  <div id="outlet" class="w-100">
    <div id="main-title" class="d-flex justify-content-between p-5">
      <div>
        <h2>CA Hispanic Chamber of Commerce Dashboard</h2>
        <p>Welcome back!</p>
      </div>
      <div id="sign-out" class="d-flex">
        <div>
          <fa-icon [icon]="faSignOut"></fa-icon>
        </div>
        <p (click)="logout()">Sign Out</p>
      </div>
    </div>
    <router-outlet></router-outlet>
  </div>
</div>
